import './defect-element-view.scss'

import { faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FormApi } from 'final-form';
import Component from 'vue-class-component';

import { DefectElement, getMinimumObservations } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { DeleteValidationOverlay, EnhancedTextInput, getTranslatedString } from '@skinsoft/ui';

import { Watch } from 'vue-property-decorator';
import { DefectObservationView } from '../defect-observation-view';

@Component({
    components: {
        sDefectObservationView: DefectObservationView,
        sDeleteValidationOverlay: DeleteValidationOverlay,
        sEnhancedTextInput: EnhancedTextInput
    },
    props: ['defectElement', 'elementIndex', 'form', 'fieldName', 'deletable'],
    template: require('./defect-element-view.html')
})
export class DefectElementView extends ReactiveVue {

    public defectElement: DefectElement;
    public form: FormApi;
    public fieldName: string;
    public deletable: boolean;
    public elementIndex: number;

    // Icons
    private deleteIcon = faTrash;
    private plusIcon = faPlusCircle;

    private displayDeleteOverlay: boolean = false;
    private getTranslatedString = getTranslatedString

    // used to generate an id for v-for feature (v-bind:key)
    private lastId = 1;

    public mounted() {
        this.$on('delete-observation', (message) => {
            this.defectElement.observationAlterationDetails.splice(message.observationIndex, 1)
        })

        // Catching delete-overlay events
        this.$on('deletion-validated-topic', this.deleteElement)
        this.$on('deletion-canceled-topic', this.toggleOverlay)
    }

    public elementNameFieldName() {
        return `${this.fieldName}.element.translatedString.${this.$i18n.locale}`
    }

    public elementPrecisionFieldName() {
        return `${this.fieldName}.precision.translatedString.${this.$i18n.locale}`
    }

    public observationFieldName(index) {
        return `${this.fieldName}.observationAlterationDetails[${index}`
    }

    public get elementName() {
        return getTranslatedString(this.defectElement.element, this.$i18n.locale)
    }

    public createObservation() {
        if (!this.defectElement.observationAlterationDetails) {
            this.defectElement.observationAlterationDetails = [];
        }
        this.defectElement.observationAlterationDetails.push({
            id: this.lastId++,
            materialAlterations: [],
            typeOfObservation: ""
        })
    }

    public deleteElement() {
        this.$parent.$emit('delete-element', { elementIndex: this.elementIndex })
    }

    public toggleOverlay() {
        this.displayDeleteOverlay = !this.displayDeleteOverlay;
    }

    @Watch('defectElement', { immediate: true })
    public onDefectElementChange() {
        this.displayDeleteOverlay = false;
        if (!this.defectElement.observationAlterationDetails) {
            this.defectElement.observationAlterationDetails = getMinimumObservations(this.$i18n.locale)
        }
    }
}